module.exports = __webpack_public_path__ + "static/media/clover-win.15cdc9db.png";